import { RETAINER_ATTRIBUTES } from './constants';

export const retainerAttributeTypes = {
  [RETAINER_ATTRIBUTES.RETAINER_CUT_TYPE]: Number
};
